// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ((chunkId === 187 ? "codeSnippet" : chunkId) + "." + {"187":"f7155874349fc9070531","848":"8d39a4d2643138535a61"}[chunkId] + ".js");